import Component from 'flarum/common/Component';
/**
 * The progress ring: an SVG circle whose stroke is the share done.
 *
 * Drawn with `stroke-dasharray` on a circle of circumference 100 (r = 15.915),
 * so the dash IS the percentage — no maths in the view, and it animates with a
 * plain CSS transition when the number moves.
 */
export default class Ring extends Component {
  view() {
    const {
      done,
      total,
      size = 36,
      label
    } = this.attrs;
    const share = total ? Math.round(done / total * 100) : 0;
    return m("span", {
      className: "OnrampRing",
      style: {
        width: `${size}px`,
        height: `${size}px`
      }
    }, m("svg", {
      viewBox: "0 0 36 36",
      "aria-hidden": "true"
    }, m("circle", {
      className: "OnrampRing-track",
      cx: "18",
      cy: "18",
      r: "15.915"
    }), share > 0 ? m("circle", {
      className: "OnrampRing-fill",
      cx: "18",
      cy: "18",
      r: "15.915",
      "stroke-dasharray": `${share} ${100 - share}`,
      "stroke-dashoffset": "25"
    }) : null), label !== undefined ? m("span", {
      className: "OnrampRing-label"
    }, label) : null);
  }
}
flarum.reg.add('ernestdefoe-onramp', 'forum/components/Ring', Ring);